/* ============================
   Conformity Services - Theme JS
   ============================ */

(function() {
  'use strict';

  /* ---- Mobile Navigation ---- */
  const mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileOverlay = document.querySelector('[data-mobile-overlay]');
  const siteHeader = document.querySelector('[data-header]');

  function setMobileMenu(open) {
    mobileMenu.classList.toggle('is-open', open);
    mobileToggle.setAttribute('aria-expanded', open);
    document.body.classList.toggle('overflow-hidden', open);
    if (mobileOverlay) mobileOverlay.classList.toggle('is-visible', open);
    if (siteHeader) siteHeader.classList.toggle('menu-open', open);
  }

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function() {
      setMobileMenu(!mobileMenu.classList.contains('is-open'));
    });

    if (mobileOverlay) {
      mobileOverlay.addEventListener('click', function() { setMobileMenu(false); });
    }

    mobileMenu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() { setMobileMenu(false); });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) setMobileMenu(false);
    });
  }

  /* ---- Sticky Header ---- */
  const header = document.querySelector('[data-header]');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;
      header.classList.toggle('is-scrolled', currentScroll > 20);
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* ---- Intersection Observer for Scroll Animations ---- */
  function initScrollAnimations() {
    if (!('IntersectionObserver' in window)) return;
    var animatedElements = document.querySelectorAll('[data-animate]');
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          // Apply stagger delay based on data attribute or inline style
          var delay = entry.target.getAttribute('data-animate-delay');
          if (delay) {
            entry.target.style.transitionDelay = (parseInt(delay) * 0.1) + 's';
          }
          // Extract animation-delay from inline style and apply as transition-delay
          var inlineStyle = entry.target.getAttribute('style') || '';
          var delayMatch = inlineStyle.match(/animation-delay:s*(d+)ms/);
          if (delayMatch) {
            entry.target.style.transitionDelay = (parseInt(delayMatch[1]) / 1000) + 's';
          }
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -60px 0px' });

    animatedElements.forEach(function(el) { observer.observe(el); });
  }
  initScrollAnimations();

  // Re-init on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', initScrollAnimations);

  /* ---- Smooth Scroll for Anchor Links ---- */
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

})();
